import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react"; // icônes (incluses via lucide-react)

export default function Photos({ gallery }) {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // 🔒 Bloquer le scroll quand une image est ouverte
  useEffect(() => {
    if (selectedIndex !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedIndex]);

  // ⌨️ Fermer avec la touche Échap
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setSelectedIndex(null);
      if (e.key === "ArrowRight" && selectedIndex !== null)
        setSelectedIndex((i) => (i + 1) % gallery.length);
      if (e.key === "ArrowLeft" && selectedIndex !== null)
        setSelectedIndex((i) => (i - 1 + gallery.length) % gallery.length);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedIndex, gallery.length]);


   // 📱 Swipe mobile
  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].screenX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].screenX;
    const deltaX = touchEndX.current - touchStartX.current;

    if (Math.abs(deltaX) > 50) {
      if (deltaX > 0) {
        // Swipe droite → photo précédente
        setSelectedIndex(
          (selectedIndex - 1 + gallery.length) % gallery.length
        );
      } else {
        // Swipe gauche → photo suivante
        setSelectedIndex((selectedIndex + 1) % gallery.length);
      }
    }
  };


  return (
    <section id="photos" className="max-w-6xl mx-auto px-6 py-16">
      <h3 className="text-2xl font-bold">Photos</h3>
      <p className="mt-2 text-slate-600"></p>
      {/* Grille d’images */}
      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        {gallery.map((src, i) => (
          <div
            key={i}
            className="rounded-xl overflow-hidden bg-black aspect-square flex items-center justify-center group cursor-pointer"
            onClick={() => setSelectedIndex(i)}
          >
            <img
              src={`https://api.palladium.rocks/images/${src}`}
              alt={`media-${i}`}
              loading="eager"
              className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105 will-change-transform"
            />
          </div>
        ))}
      </div>

      {/* Lightbox (image agrandie) */}
      {selectedIndex !== null && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 select-none"
          onClick={() => setSelectedIndex(null)}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {/* Empêche le clic sur l’image de fermer la lightbox */}
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            <img
              src={`https://api.palladium.rocks/images/${gallery[selectedIndex]}`}
              alt="Agrandie"
              loading="eager"
              className="w-auto h-auto max-w-[90vw] max-h-[90vh] object-contain rounded-xl shadow-lg"
            />

            {/* Bouton de fermeture */}
            <button
              onClick={() => setSelectedIndex(null)}
              className="absolute top-6 right-6 text-white text-3xl font-bold hover:text-slate-300"
            >
              ×
            </button>

            {/* Flèche gauche */}
            <button
              onClick={() =>
                setSelectedIndex(
                  (selectedIndex - 1 + gallery.length) % gallery.length
                )
              }
              className="absolute left-[-80px] top-1/2 -translate-y-1/2 text-white p-3 hover:text-slate-300"
            >
              <ChevronLeft size={48} />
            </button>

            {/* Flèche droite */}
            <button
              onClick={() =>
                setSelectedIndex((selectedIndex + 1) % gallery.length)
              }
              className="absolute right-[-80px] top-1/2 -translate-y-1/2 text-white p-3 hover:text-slate-300"
            >
              <ChevronRight size={48} />
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
